import React, { useState, useEffect } from 'react';
import { Tabs, Tab, Row, Col, Accordion, Card } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import MonitoringGraphsView from '@components/dashboards/GraphView/MonitoringGraphsView';
import { DASHBOARD_TAB_KEY } from '@awp/constants';
import { fetchDashboardViews } from '@stores/dashboardViewPageSlice';
import CardHeaderToggle from '@components/Common/Accordion/CardHeaderToggle';
import { selectFullScreen } from '@awp/stores/fullScreenSlice';

const VisualContainer = ({ id }) => {
  const [tabKey, setTabKey] = useState(DASHBOARD_TAB_KEY.TIMEBASED);
  const dispatch = useDispatch();
  const fullScreen = useSelector(selectFullScreen);

  let cardClass = !fullScreen.enabled ? 'page-card' : 'page-card-max';
  useEffect(() => {
    dispatch(fetchDashboardViews());
  }, []);

  useEffect(() => {
    cardClass = !fullScreen.enabled ? 'page-card' : 'page-card-max';
  }, [fullScreen]);

  return (
    <Accordion defaultActiveKey="0">
      <Card border="light" className={cardClass}>
        {!fullScreen.enabled && <CardHeaderToggle eventKey="0" as="h4" title={'Views'} />}
        <Accordion.Collapse eventKey="0">
          <Card.Body>
            <Row>
              <Col>{/* <GraphActions graphId={id} /> */}</Col>
            </Row>
            {!fullScreen.enabled && (
              <Tabs
                id="graph-tabs"
                activeKey={tabKey}
                onSelect={(k) => setTabKey(k)}
                className="mb-3 tab"
                transition={false}
              >
                <Tab eventKey={DASHBOARD_TAB_KEY.TIMEBASED} title="Time-Based"></Tab>
                <Tab eventKey={DASHBOARD_TAB_KEY.OVERVIEW} title="Overview"></Tab>
              </Tabs>
            )}

            <MonitoringGraphsView tabKey={tabKey} />
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  );
};

VisualContainer.propTypes = {
  id: PropTypes.any.isRequired,
};

export default VisualContainer;
